import type { AbstractEntity } from './api'
import { Group } from './groups'
import { Sector } from './sectors'

export type UserType = 'ADMIN' | 'USER'

export interface User extends AbstractEntity {
  name: string
  email: string
  sectorId: string
  groupId: string
  password?: string
  type: UserType
  isActive: boolean
  emailVerified: boolean
  lastLoginAt?: string
  emailVerifiedAt?: string
  tenantId: string
  group: Group
  sector: Sector
  /** @deprecated removido — permissões são por planner */
  accessLevelId?: string
  accessLevel?: { name: string; displayName?: string; permissions?: string[] }
}

export interface CreateUserDto {
  name: string
  email: string
  password: string
  sectorId: string
  groupId: string
  type?: UserType
  isActive?: boolean
}

export interface UpdateUserDto {
  name?: string
  email?: string
  password?: string
  sectorId?: string
  groupId?: string
  type?: UserType
  isActive?: boolean
}

export interface UserFilters {
  groupId?: string
  sectorId?: string
  isActive?: boolean
  activeOnly?: boolean
  search?: string
  status?: string
  sort?: string
}

export interface ChangePasswordDto {
  currentPassword: string
  newPassword: string
}

export function isTenantAdminType(type?: string): boolean {
  if (!type) return false
  return type.toUpperCase() === 'ADMIN' || type.toLowerCase() === 'admin'
}

export function userTypeLabel(type?: UserType | string): string {
  return isTenantAdminType(type) ? 'Administrador' : 'Usuário'
}
